import { RecoilRoot } from "recoil";
import "./src/styles/global.css";
import React from "react";

export const wrapPageElement = ({ element }) => {
  return <RecoilRoot>{element}</RecoilRoot>;
};
